
import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Country } from '@precheckin/models/country.model';
import { Nationality } from '@precheckin/models/nationality.model';
import { CountriesService } from '@precheckin/services/countries.service';
import { NationalitiesService } from '@precheckin/services/nationalities.service';
import { take } from 'rxjs';
import { AppStoreKeys } from 'src/app/store/store-keys.module';

import {
  GetCountries,
  GetNationalities
} from './precheckin-countries-nationalities-state.actions';
import {
  defaultCountriesNationalitiesState,
  IPreCheckinCountriesNationalitiesStateModel
} from './precheckin-countries-nationalities-state.model';

@State<IPreCheckinCountriesNationalitiesStateModel>({
  name: AppStoreKeys.PreCheckinCountriesNationalities,
  defaults: defaultCountriesNationalitiesState
})
@Injectable()
export class PreCheckinCountriesNationalitiesState {
  constructor(
    private _countryService: CountriesService,
    private _nationalityService: NationalitiesService
  ) { }

  @Selector()
  public static isPreCheckinNationalityReady(
    state: IPreCheckinCountriesNationalitiesStateModel
  ): boolean {
    return state.isPreCheckinCountryNationalityReady;
  }

  @Selector()
  public static countries(state: IPreCheckinCountriesNationalitiesStateModel): Array<Country> {
    return state.countries;
  }

  @Selector()
  public static nationalities(
    state: IPreCheckinCountriesNationalitiesStateModel
  ): Array<Nationality> {
    return state.nationalities;
  }

  @Action(GetCountries)
  getCountries(
    ctx: StateContext<IPreCheckinCountriesNationalitiesStateModel>
  ): void {
    if (ctx.getState().countries.length) {
      ctx.patchState({
        isPreCheckinCountryNationalityReady: true,
        countries: ctx.getState().countries
      });
    } else {
      ctx.patchState({
        isPreCheckinCountryNationalityReady: false
      });

      this._countryService
        .get()
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            ctx.patchState({
              isPreCheckinCountryNationalityReady: true,
              countries: response
            });
          },
          error: () => {
            ctx.patchState({
              isPreCheckinCountryNationalityReady: true,
              countries: new Array<Country>()
            });
          }
        });
    }
  }

  @Action(GetNationalities)
  getNationalities(
    ctx: StateContext<IPreCheckinCountriesNationalitiesStateModel>
  ): void {
    if (ctx.getState().nationalities.length) {
      ctx.patchState({
        isPreCheckinCountryNationalityReady: true,
        nationalities: ctx.getState().nationalities
      });
    } else {
      this._nationalityService
        .get()
        .pipe(take(1))
        .subscribe({
          next: (response) => {
            ctx.patchState({
              isPreCheckinCountryNationalityReady: true,
              nationalities: response
            });
          },
          error: () => {
            ctx.patchState({
              isPreCheckinCountryNationalityReady: true,
              nationalities: new Array<Nationality>()
            });
          }
        });
    }
  }
}
